(() => {
  const sidebar = document.currentScript?.previousElementSibling;
  if (!sidebar?.matches('[data-vehicle-navigation]')) return;
  const list = sidebar.querySelector('[data-vehicle-list]');
  const status = sidebar.querySelector('[data-vehicle-status]');
  const config = sidebar.dataset;
  const params = new URLSearchParams(location.search);
  const gid = value => value ? (String(value).startsWith('gid://') ? String(value) : `gid://shopify/Metaobject/${value}`) : '';
  const productModels = (config.productModel || '').split(',').filter(Boolean).map(gid);
  const activeModel = params.getAll(config.modelParameter).join(',');
  const collator = new Intl.Collator(document.documentElement.lang || 'de', { numeric: true, sensitivity: 'base' });

  async function readEntries(view) {
    const entries = [];
    let url = new URL(config.catalogUrl, location.origin);
    url.searchParams.set('view', view);
    const visited = new Set();
    while (url) {
      if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid catalog pagination');
      visited.add(url.href);
      const response = await fetch(url.href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Catalog request failed');
      const data = await response.json();
      if (!Array.isArray(data.entries)) throw new Error('Invalid catalog response');
      entries.push(...data.entries);
      url = data.next ? new URL(data.next, location.origin) : null;
      if (url) url.searchParams.set('view', view);
    }
    return entries;
  }

  async function load() {
    const [manufacturers, models] = await Promise.all([
      readEntries('vehicle-brands'), readEntries('vehicle-models')
    ]);
    const brands = new Map();
    for (const entry of manufacturers) {
      if (entry.id && typeof entry.label === 'string' && entry.label.trim()) {
        brands.set(gid(entry.id), { id: gid(entry.id), label: entry.label, models: new Map() });
      }
    }
    for (const entry of models) {
      const brand = brands.get(gid(entry.brandId));
      if (brand && entry.id && typeof entry.label === 'string' && entry.label.trim()) {
        brand.models.set(gid(entry.id), { id: gid(entry.id), label: entry.label, filterValue: entry.filterValue || gid(entry.id) });
      }
    }
    const selectedModels = activeModel ? activeModel.split(',').map(gid) : productModels;
    const activeBrand = params.get('vehicle_brand')
      || [...brands.values()].find(brand => selectedModels.some(id => brand.models.has(id)))?.id;
    const link = (brand, model) => {
      const hasSearchTerm = config.query.trim() && config.query.trim() !== '*';
      const url = new URL(hasSearchTerm ? config.searchUrl : config.catalogUrl, location.origin);
      if (hasSearchTerm) {
        url.searchParams.set('q', config.query);
        url.searchParams.set('type', 'product');
      }
      url.searchParams.set('vehicle_brand', brand.id);
      url.searchParams.set('vehicle_scope', model ? 'model' : 'brand');
      // Models already identify their manufacturer. Do not require a second product metafield.
      if (model) url.searchParams.set(config.modelParameter, model.filterValue);
      else if (brand.models.size) url.searchParams.set(config.modelParameter, [...brand.models.values()].map(model => model.filterValue).join(','));
      else url.searchParams.set(config.modelParameter, 'gid://shopify/Metaobject/0');
      const a = document.createElement('a');
      a.href = url.pathname + url.search;
      a.textContent = model ? model.label : `Alle Modelle von ${brand.label}`;
      if (brand.id === activeBrand && (model ? (!activeModel || selectedModels.length === 1) && selectedModels.includes(model.id) : params.get('vehicle_scope') === 'brand')) {
        a.classList.add('is-active');
        a.setAttribute('aria-current', 'true');
      }
      const li = document.createElement('li');
      li.append(a);
      return li;
    };
    const fragment = document.createDocumentFragment();
    for (const brand of [...brands.values()].sort((a, b) => collator.compare(a.label, b.label))) {
      const details = document.createElement('details');
      details.className = 'vehicle-brand';
      details.open = brand.id === activeBrand;
      const summary = document.createElement('summary');
      const label = document.createElement('span');
      label.textContent = brand.label;
      const toggle = document.createElement('span');
      toggle.className = 'vehicle-toggle';
      toggle.textContent = '+';
      toggle.setAttribute('aria-hidden', 'true');
      summary.append(label, toggle);
      const ul = document.createElement('ul');
      ul.append(link(brand));
      for (const model of [...brand.models.values()].sort((a, b) => collator.compare(a.label, b.label))) ul.append(link(brand, model));
      details.append(summary, ul);
      fragment.append(details);
    }
    const heading = document.querySelector('[data-vehicle-heading]');
    const resultLabel = document.querySelector('[data-vehicle-result-label]');
    const selectedBrand = brands.get(activeBrand);
    if (selectedBrand && (activeModel || params.has('vehicle_brand'))) {
      const selected = selectedBrand.models.get(selectedModels[0]);
      const title = params.get('vehicle_scope') !== 'brand' && selectedModels.length === 1 && selected
        ? `${selectedBrand.label} ${selected.label}` : selectedBrand.label;
      if (heading) heading.textContent = title;
      if (resultLabel) resultLabel.textContent = `für ${title}`;
    }
    const form = document.querySelector('[data-vehicle-search-form]');
    if (form) {
      for (const key of ['vehicle_brand', 'vehicle_scope']) {
        if (!params.has(key)) continue;
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = key; input.value = params.get(key);
        form.append(input);
      }
    }
    list.replaceChildren(fragment);
    status.textContent = brands.size ? '' : 'Noch keine Fahrzeuge verfügbar.';
    status.hidden = brands.size > 0;
  }
  load().catch(() => {
    status.textContent = 'Fahrzeuge konnten nicht geladen werden. Bitte erneut versuchen.';
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.textContent = 'Erneut laden';
    retry.addEventListener('click', () => location.reload());
    status.append(' ', retry);
  }).finally(() => list.setAttribute('aria-busy', 'false'));
})();
